import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormFileInputField from 'modules/ui/editform/fields/EditFormFileInputField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import FmFileEditService from 'app/admin/fileManager/service/FmFileEditService';
import { withRouter, useParams } from 'react-router';

const config = data => {
	return {
		key: 'FmFileEditForm',
		text: 'Fájl',
		textKey: 'FmFileEditForm',
		service: FmFileEditService,
		defaultValue: () =>
			new Promise((resolve, reject) => {
				FmFileEditService.create().then(response => {
					resolve({
						...response,
						...{
							parentDirectory: data.directory !== '0' ? data.directory : null,
							parentStorage: data.storage
						}
					});
				});
			}),
		fields: [
			{
				key: 'file',
				text: 'Fájl',
				textKey: 'file',
				component: EditFormFileInputField,
				service: FmFileEditService,
				required: true
			},
			{
				key: 'fileName',
				text: 'Fájl átnevezése',
				textKey: 'fileName',
				component: EditFormTextField,
				required: false
			},
			{
				key: 'copyright',
				text: 'Copyright',
				textKey: 'copyright',
				component: EditFormTextField,
				required: false
			}
		]
	};
};

function FmFileEditForm() {
	const { directory, storage } = useParams();
	const myConfig = config({
		directory,
		storage
	});

	return <EditFormPage config={myConfig} />;
}

export default withRouter(FmFileEditForm);
